import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const env_factor_options = apiUrl + "/env_factor_options";
const routes = {
  label: "Environmental Factor Options",
  root: env_factor_options,
  get_all: env_factor_options + "/get_all",
  search_materials: env_factor_options + "/search_materials",
  browse_all: env_factor_options + "/browse_all",
};

export const Env_Factor_Options = {
  getAll: () => getWithToken(routes.get_all),
  searchMaterials: (search_term, include_epds = true) => postWithToken(routes.search_materials, { search_term, include_epds }),
  browseAll: (params = {}) => postWithToken(routes.browse_all, params),
};
